export const TIPOS = ['anno_lectivo', 'ensennanza', 'nivel', 'curso', 'modalidad', 'grupo'];

export const TIPO_HIJOS_KEY = {
  anno_lectivo: 'ensennanzas',
  ensennanza: 'niveles',
  nivel: 'cursos',
  curso: 'modalidades',
  modalidad: 'grupos',
};

export const labels = {
  anno_lectivo: 'Año lectivo',
  ensennanza: 'Enseñanza',
  nivel: 'Nivel',
  curso: 'Curso',
  modalidad: 'Modalidad',
  grupo: 'Grupo',
  ensennanza_children: 'Opciones',
  curso_children: 'Opciones',
  nivel_children: 'Opciones',
};

export function mostrarDatoEstructura(item) {
  return item.etiqueta || item.abbr || item.nombre || item.codigo || item.label || '';
}

export function parsearNombreGrupoConProfesor(texto) {
  const separador = texto.indexOf(' - ');
  if (separador === -1) return null;

  const profesor = texto.slice(separador + 3).trim();
  if (!profesor.includes(',')) return null;

  return {
    grupo: texto.slice(0, separador).trim(),
    profesor,
  };
}
